import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { MainForm } from 'src/modules/modules/components/mainForm';
import { SelectModuleType } from 'src/modules/modules/components/selectModuleType';
import { useFillFormForUpdate } from 'src/modules/modules/hooks/useFillFormForUpdate';
import { useWizardContext } from 'src/modules/modules/hooks/useWizardContext';
import { Loader } from 'src/shared/components/loader';
import { LoadError } from 'src/shared/components/loadError';
export function Steps({ step }) {
    if (step === 'moduleType') {
        return _jsx(SelectModuleType, {});
    }
    return _jsx(MainForm, {});
}
export const Body = ({ submit }) => {
    const { moduleId } = useParams();
    const form = useFormContext();
    const { currentStep } = useWizardContext();
    const { isFormLoading, isError, refetch } = useFillFormForUpdate(moduleId);
    if (isFormLoading) {
        return _jsx(Loader, { full: "screen", "data-testid": "module-edition-loader" });
    }
    if (isError) {
        return _jsx(LoadError, { onTryAgain: refetch, className: "h-full" });
    }
    return (_jsx("form", { id: "module-form", onSubmit: form.handleSubmit(submit), children: _jsx(Steps, { step: currentStep }) }));
};
